export default __webpack_public_path__ + "src/images/icon_slide-b111ed.png";